<template>
  <div class="md:l-6 mb-2 md:mb-6 w-full md:w-1/2 md:pl-4">
    <div
      class="
        relative
        flex flex-col
        items-center
        overflow-hidden
        px-4
        md:px-8
        pt-10
        pb-12
        md:pb-14
      "
      :style="containerStyle"
    >
      <img
        class="tshirt-img w-3/4 relative z-10"
        :src="getRandImg()"
        alt=""
      />
      <blobber :gradient="gradient" class="absolute z-0 tshirt" />
      <div class="flex flex-col items-center">
        <h2 class="text-xl mt-4 md:mt-6">Men’s FOMO Tshirt</h2>
        <a
          class="
            bg-white
            px-4
            py-2
            text-black
            mt-4
            md:mt-6
            block
            text-center
            rounded
            uppercase
            font-bold
          "
          href=""
          >Buy Now</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import Blobber from "@/components/Blobber";

import { getRandomInt } from "../util/common.util";
import gradients from "../util/gradients";

import mock1 from "@/assets/img/mock1.png";
import mock2 from "@/assets/img/mock2.png";
import mock3 from "@/assets/img/mock3.png";
import mock4 from "@/assets/img/mock4.png";
import mock5 from "@/assets/img/mock5.png";
import mock6 from "@/assets/img/mock6.png";
import mock7 from "@/assets/img/mock7.png";
import mock8 from "@/assets/img/mock8.png";
import mock9 from "@/assets/img/mock9.png";
import mock10 from "@/assets/img/mock10.png";

export default {
  name: "tshirt",
  components: {
    Blobber,
  },
  data() {
    return {
      gradient: gradients[getRandomInt(0, gradients.length)].colors,
    };
  },
  computed: {
    containerStyle: function () {
      return {
        background: `linear-gradient(${getRandomInt(0, 360)}deg, ${
          this.gradient[0]
        }, ${this.gradient[1]})`,
      };
    },
  },
  methods: {
    getRandImg() {
      let arr = [mock1, mock2, mock3, mock4, mock5, mock6, mock7, mock8, mock9, mock10];
      return arr[Math.floor(Math.random() * 10)];
    },
  },
};
</script>

<style scoped>
.tshirt {
  top: 25%;
}
@media screen and (min-width: 640px) {
  .tshirt-wrapper {
    width: 350px;
    height: 450px;
  }
}

@media screen and (min-width: 768px) {
  .tshirt-wrapper {
    width: 525px;
    height: 675px;
  }
}

@media screen and (min-width: 1280px) {
  .tshirt-wrapper {
    width: 700px;
    height: 900px;
  }
}
</style>